export enum OpportunityStages {
    PRIMO_CONTATTO = 'First contact',
    RICHIESTA_DI_OFFERTA = 'Offer request',
    BUDGET_PRONTO = 'Budget ready',
    OFFERTA_INVIATA = 'Offer sent',
    SOSPESA_DAL_CLIENTE = 'Suspended by the client',
    RINUNCIATA_DA_EXTRAVEGA = 'Renounced by Extravega',
    LOST = 'Lost',
    WON = 'Won',
}